var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0625 150C112.362 150 131.25 131.112 131.25 107.812C131.25 84.513 112.362 65.625 89.0625 65.625C65.763 65.625 46.875 84.513 46.875 107.812C46.875 131.112 65.763 150 89.0625 150Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.109 173.438C120.609 165.059 102.398 161.719 89.0625 161.719C62.9414 161.719 9.375 177.738 9.375 209.766V234.375H97.2656V224.959C97.2656 213.826 101.953 202.664 110.156 193.359C116.701 185.93 125.865 179.033 137.109 173.438Z",
    fill: "#FF9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.219 168.75C168.709 168.75 107.812 187.594 107.812 225V253.125H290.625V225C290.625 187.594 229.729 168.75 199.219 168.75Z",
    fill: "#FF9900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.219 150C227.696 150 250.781 126.915 250.781 98.4375C250.781 69.9603 227.696 46.875 199.219 46.875C170.742 46.875 147.656 69.9603 147.656 98.4375C147.656 126.915 170.742 150 199.219 150Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c3b60947c021d9b9a84ae0f3941a160d.svg";
export { ForwardRef as ReactComponent };